var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNecklaceOuter = function SvgNecklaceOuter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 45,
    height: 29,
    viewBox: "0 0 1.13 0.72",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.45.12C.43.28.45.3.27.35.18.37.12.38.09.47.05.57.05.63.14.63c.17 0 .33 0 .5.02.09 0 .28.01.37 0 .03-.01.05.01.06-.06C1.08.48 1.04.41.93.37.85.34.78.37.72.26A.36.36 0 0 1 .7.15",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.54.23C.57.23.77.25.78.22.8.16.8.15.79.08.77.01.36.01.37.06c0 .15-.09.16.17.17z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.05,
    strokeMiterlimit: 22.9256
  })));
};

export default SvgNecklaceOuter;